import { render, staticRenderFns } from "./smstask.vue?vue&type=template&id=5c9a98c6"
import script from "./smstask.vue?vue&type=script&lang=js"
export * from "./smstask.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports